import React from "react";

function AppFooter() {
  const curYr = new Date().getFullYear();
  return (
    <footer className="bg-white shadow-md py-4 px-8 flex justify-between items-center text-sm">
      Copyright &copy; {curYr} Marriott . All rights reserved.
      <div className="float-right d-none d-sm-inline-block">{/* <b>Version</b> 3.2.0 */}</div>
    </footer>
  );
}

export default AppFooter;
